class PredictiveSearch extends HTMLElement {
    
  constructor() {   
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');  
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');       
    this.openBtn = document.querySelector('#openSearch');
    this.closeBtn = this.querySelector('#closePrdctv'); 
    this.gotoSearchWithTerm = this.querySelector('#gotoSearchWithTerm');
    
    this.dealWithSafariWankery();
    this.setupEventListeners();               
  }
   
  
  dealWithSafariWankery() {
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      // console.log('Oh, you are using Safari! What a piece of shit browser.');
      this.querySelector('.forSafariFix').classList.add('isSafari')
    }
  }

  
  setupEventListeners() {    
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));   
    this.input.addEventListener('focus', this.onFocus.bind(this));     
    this.openBtn ? this.openBtn.addEventListener('click', () => { this.open() }) : null; 
    this.closeBtn ? this.closeBtn.addEventListener('click', () => { this.close() }) : null;
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }
 
  
  open() {
    this.openBtn.setAttribute('aria-expanded', true); 
    this.setAttribute('open', '');
    this.classList.remove('none');
    setTimeout(()=>{ this.classList.remove('opacity-0') },10);
    this.input.focus(); 
    document.documentElement.classList.add('overflow-hidden');
  }
  
  
  close() { 
    this.openBtn.setAttribute('aria-expanded', false); 
    this.input.value = '';
    this.removeAttribute('open');
    this.removeAttribute('results');
    this.classList.add('opacity-0');
    setTimeout(()=>{ this.classList.add('none') },310);
    this.clearResultsPanel();
    this.toggleGotoSearch(false);
    document.documentElement.classList.remove('overflow-hidden');
  }
  
  
  onKeydown(event) {   
    switch (event.code) {
      case 'Escape':
        console.log(this.getQuery().length)
        if (this.getQuery().length <= 0) this.close();
        break;      
    }
  }
  
  
  getQuery() {
    return this.input.value.trim();
  } 
  
  
  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }


  onChange() {
    const searchTerm = this.getQuery();
    searchTerm.length === 0 ? (this.clearResultsPanel(), this.toggleGotoSearch(false), this.removeAttribute('results')) : (this.getSearchResults(searchTerm), this.toggleGotoSearch(true));    
    this.writeTerm(searchTerm);
  }


  onFocus() {
    const searchTerm = this.getQuery();
    if (!searchTerm.length) return;
    this.getSearchResults(searchTerm);  
  } 


  clearResultsPanel() {
	this.predictiveSearchResults.innerHTML = '';
  }
  

  getSearchResults(searchTerm) {
    
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();  
    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,collection&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {         
        if (!response.ok) {          
          var error = new Error(response.status);
          this.clearResultsPanel();
          this.toggleGotoSearch(false);
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-results').innerHTML;      
        this.cachedResults[queryKey] = resultsMarkup;       
        this.renderSearchResults(resultsMarkup); 
      }).then(() => {
		setTimeout(() => {                 
          this.toggleGotoSearch(true);  
        }, 300);        
      })
      .catch((error) => {
        this.clearResultsPanel();
        throw error;
      }); 
  }


  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);   
  }


  toggleGotoSearch(state) {  
       
      if(state === true) {      
        this.gotoSearchWithTerm.classList.remove('none');
        setTimeout(()=>{ this.gotoSearchWithTerm.classList.remove('opacity-0') },1000);       
      } else {      
        this.gotoSearchWithTerm.classList.add('opacity-0', 'none');
        //setTimeout(()=>{ this.gotoSearchWithTerm.classList.add() },400);      
      }	
    
  }
  
  
  writeTerm(term) {
    this.gotoSearchWithTerm.querySelector('.theTerm').textContent = `${term}`;
  }

}

customElements.define('predictive-search', PredictiveSearch);
